/**
 * Finds the next item in a list
 * @param items A list of items that can potentially have a `disabled` attribute
 * @param idx The location of a cursor pointing to the current location within `items`
 * @param options Options that allow you to configure the next item.
 * @returns
 */
export function nextItem(items, idx, options) {
    if (items.length < 2)
        return;
    let cursor = idx;
    while (true) {
        if (cursor < items.length - 1) {
            cursor++;
        }
        else if (options?.wrapEnd === true) {
            cursor = 0;
        }
        else
            return;
        if (cursor === idx)
            return;
        const item = items[cursor];
        const shouldSkip = options === undefined ? false : options.skipIf === undefined ? false : options.skipIf(item);
        if (shouldSkip !== true)
            return cursor;
    }
}
